/**
 * 审批档序号 (后端给的数字; ⛔ 前端不判档)
 *
 * @param {object} preview 退费预览对象（各 modal 自己的 `this.preview`）
 */
export function tierOrder(preview) {
  const p = preview;
  if (!p || p.tier_order === null || p.tier_order === undefined) return 0;
  const n = Number(p.tier_order);
  return isFinite(n) ? Math.floor(n) : 0;
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/utils/RefundTier', { tierOrder: tierOrder, });